import { render, staticRenderFns } from "./TokenDistribution.vue?vue&type=template&id=5335b2f2&scoped=true&"
import script from "./TokenDistribution.vue?vue&type=script&lang=js&"
export * from "./TokenDistribution.vue?vue&type=script&lang=js&"
import style0 from "./TokenDistribution.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TokenDistribution.vue?vue&type=style&index=1&id=5335b2f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5335b2f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDataTable,VRow})
